import styled from "styled-components";
import { device } from "../../config/sizes";

export const HeaderWrapper = styled.header`
  position: absolute;
  top: 4rem;
  right: 5rem;
  left: 5rem;
  z-index: 100;

  @media ${device.tablet} {
    top: 1.5rem;
    right: 2rem;
    left: 2rem;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
`;

export const HeaderSpacer = styled.div`
  margin-right: auto;
`;

export const HeaderLogo = styled.img`
  height: 3.25rem;
  opacity: 0.15;

  @media ${device.tablet} {
    display: none;
  }
`;

export const HeaderMenu = styled.nav`
  width: 50px;
  margin-left: auto;
  cursor: pointer;
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1  {
    font-family: "Inter";
    font-weight: normal;
    font-size: 3vw;
    text-align: center;
  }

  img {
    width: 60vw;
    filter: invert(25%) sepia(6%) saturate(5916%) hue-rotate(245deg)
      brightness(92%) contrast(76%);
  }

  .LogoDesktop {
    display: block;
    margin-bottom: 1em;
  }

  .LogoMobile {
    display: none;
    margin-bottom: 1.5em;
  }

  @media ${device.tablet} {
    h1 {
      font-size: 1.5em;
    }

    .LogoDesktop {
      display: none;
    }

    .LogoMobile {
      display: block;
    }
  }

  @media ${device.mobile} {
    h1 {
      font-size: 1em;
    }
  }
`;

export const Imprint = styled.div<{ isFloating?: boolean }>`
  position: ${({ isFloating }) => (isFloating ? "absolute" : "static")};
  right: -9vw;
  bottom: -75vh;
  font-family: Inter, sans-serif;
  font-size: 12px;
  z-index: 1002;
  transform: rotate(270deg);

  &.imprintMobile {
    display: none;

    @media ${device.tablet} {
      display: block;
    }
  }

  @media ${device.tablet} {
    left: 0;
    bottom: 5rem;
    transform: rotate(0deg);
    display: none;
  }

  

  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    li {
      padding-right: 15px;
    }

    a {
      color: black;
      text-decoration: none;
      padding-right: 0;
      opacity: 0.3;

      &:hover {
        opacity: 0.6;
      }
    }
  }
`;
